import { ChangeDetectionStrategy, Component } from '@angular/core';
import { PalantirSkeletonComponent } from '../../../skeleton/skeleton.component';

@Component({
  selector: 'palantir-table-skeleton',
  templateUrl: './skeleton.component.html',
  styleUrls: ['./skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [PalantirSkeletonComponent],
})
export class PalantirTableSkeletonComponent {}
